/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface ICollaborativeEditingReconnectMessage extends IMessage {
	id: string;
	lastKnowVersion: number;
	bundleVersion: string;
}

export default class CollaborativeEditingReconnectMessage extends Message {
	public static readonly TYPE: string = '12';

	public static readonly READABLE_TYPE_NAME: string = 'reconnectToDocument';

	public static readonly DESCRIPTOR_NAME: string = 'CollaborativeEditingReconnectMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			id: {
				type: 'string',
				id: 1
			},
			bundleVersion: {
				type: 'string',
				id: 2
			},
			lastKnowVersion: {
				type: 'uint32',
				id: 3
			}
		}
	};

	public constructor(
		public readonly id: string,
		public readonly lastKnowVersion: number,
		public readonly bundleVersion: string
	) {
		super();
	}

	public toJSON(): ICollaborativeEditingReconnectMessage {
		return {
			id: this.id,
			bundleVersion: this.bundleVersion,
			lastKnowVersion: this.lastKnowVersion
		};
	}

	public static fromJSON( data: ICollaborativeEditingReconnectMessage ): CollaborativeEditingReconnectMessage {
		return new CollaborativeEditingReconnectMessage( data.id, data.lastKnowVersion, data.bundleVersion );
	}
}
